import React from 'react';
import Footer from '../../template/layout/footer/Footer';
import Header from '../../template/layout/header/Header';
import { Link } from 'react-router-dom';
import styles from './ListingUnavailable.module.css';
import pineappleLogo from '../../images/core/pineapple-logo-black.svg';

const ListingUnavailable = () => {
    return (
        <>
            <Header />
            <div className={styles.container}>
                <img className={styles.icon} src={pineappleLogo} alt="Pineapple" />
                <h2 className={styles.heading}>This community is no longer available</h2>
                <p>
                    This property is no longer offering self-guided tours through Pineapple. Please contact the
                    leasing office directly, or reach out if you have questions.
                </p>
                <Link to="/" className={styles.btn}>
                    Back to Home
                </Link>
            </div>
            <Footer />
        </>
    );
};

export default ListingUnavailable;
